export class HtmlDTO {

    constructor(
      readonly fileName: string,
      readonly html: string
    ) {
    }
  }